import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiVisa, BaseApiTemplateService, Pagination} from '../../shared';
import {Core2Config} from '../../shared';
import { ClaimClaimantEntityClaimDocLineFavouriteLinkModel} from '../../../../../../models';
import { ApiResponseModel, PagingResponseModel } from '../../shared/api-response.model';



@Injectable({
  providedIn: 'root'
})
export class ClaimClaimantEntityClaimDocLineFavouriteLinkService extends BaseApiTemplateService<ClaimClaimantEntityClaimDocLineFavouriteLinkModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +  Core2Config.CLAIMS_PREFIX + 'claimant-entity-claim-doc-line-favourite-links/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX + Core2Config.CLAIMS_PREFIX + 'claimant-entity-claim-doc-line-favourite-links/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX + Core2Config.CLAIMS_PREFIX + 'claimant-entity-claim-doc-line-favourite-links/backoffice-ep';
    this.httpClient = http;
  }

  postFavouriteClaim(containerList: ClaimClaimantEntityClaimDocLineFavouriteLinkModel[], visa: ApiVisa): Observable<ApiResponseModel<ClaimClaimantEntityClaimDocLineFavouriteLinkModel[]>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX + Core2Config.CLAIMS_PREFIX  + 'claimant-entity-claim-doc-line-favourite-links/multiple-claim-document-lines/backoffice-ep';
    }
    return this.httpClient.post<ApiResponseModel<ClaimClaimantEntityClaimDocLineFavouriteLinkModel[]>>(
      this.apiUrl,
      containerList,
      this.getHttpHeader(visa)
    );
  }

  getByCriteriaLoginEntityPrimaryEp(pagination: Pagination, visa: ApiVisa): Observable<PagingResponseModel<ClaimClaimantEntityClaimDocLineFavouriteLinkModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX + Core2Config.CLAIMS_PREFIX + 'claimant-entity-claim-doc-line-favourite-links/login-entity-primary-ep';
    }
    const UrlByCriteria =
      this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<ClaimClaimantEntityClaimDocLineFavouriteLinkModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }
}


